// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pP4f4BzvlBIDEN {\n  display: flex;\n  margin-right: 4px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pluginContainer": "pP4f4BzvlBIDEN"
};
export default ___CSS_LOADER_EXPORT___;
